import { render } from "./FormularioOpcaoAvaliacao.vue?vue&type=template&id=c22b4a44&scoped=true"
import script from "./FormularioOpcaoAvaliacao.vue?vue&type=script&lang=js"
export * from "./FormularioOpcaoAvaliacao.vue?vue&type=script&lang=js"

import "./FormularioOpcaoAvaliacao.vue?vue&type=style&index=0&id=c22b4a44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22b4a44"]])

export default __exports__